import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';

const CustomDrawer = ({ open, onClose, anchor = 'right', children, width }) => {
  return (
    <Drawer anchor={anchor} open={open} onClose={onClose}>
      <Box
        sx={{
          width: width || {
            xs: 300,
            sm: 450,
          },
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Box>
    </Drawer>
  );
};

export default CustomDrawer;
